<template>
  <el-menu-item
    v-if="!data.children" :index="defaultIndex+'-1'"
    @click="routeTo(data)"
  >
    <svg-icon
      :iconName="data.icon || ''"
      fillColor="var(--iconColor_6)"
    ></svg-icon>
    <template #title>{{ data.title }}</template>
  </el-menu-item>
  <el-sub-menu v-else-if="data.children" :index="defaultIndex+''"
    popper-class="menu-tootip-popper"
  >
    <template #title>
      <!-- <el-icon><component :is="data.icon" /></el-icon> -->
      <svg-icon
        :iconName="data.icon || ''"
        fillColor="var(--iconColor_6)"
      ></svg-icon>
      <span>{{ data.title }}</span>
    </template>
    <el-menu-item
      v-for="(menu, menuIndex) in data.children"
      :key="menu"
      :index="defaultIndex+'-'+(menuIndex+1)"
      @click="routeTo(menu)"
    >
      <!-- <el-icon><component :is="menu.icon" /></el-icon> -->
      <svg-icon
        :iconName="menu.icon || ''"
        fillColor="var(--iconColor_6)"
      ></svg-icon>
      <template #title>{{ menu.title }}</template>
    </el-menu-item>
  </el-sub-menu>
</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick
} from 'vue';
import { isNull, dayjs, message } from '@/utils/js/initVariable';
import router from '@/router';

// props
const props = defineProps({
  data: { type: Object, },
  defaultIndex: { type: Number, }
});
// emit
const emit = defineEmits([
  
]);

// 组件挂载前
onBeforeMount(()=>{

});
// 组件挂载后
onMounted(()=>{

});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{

});
const routeTo = (val)=>{
  router.push(val.url);
}

</script>

<style lang='less'>

</style>

<style lang='less' scoped>
.svg-icon{
  margin-left: 3px;
  margin-right: 5px;
  min-width: 18px;
  min-height: 18px;
  flex-shrink: 0;
}
:deep(.el-sub-menu__title),.el-menu-item{
  color: var(--fontColor_4);
  font-weight: bold;
}
</style>